export class ArianeElement {
    libelle: string;
    route: string;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/ariane/ariane.resources.provided.ts